import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Button from "../button";
import { toast } from "react-toastify";
import { faClockFour } from "@fortawesome/free-regular-svg-icons";
import { useDispatch, useSelector } from "react-redux";
import { EMenuActions } from "../../store";
import { useState, useEffect } from "react";
import fallbackImage from "../../Assets/placeholder.jpg";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import Skeleton from "react-loading-skeleton";

export default function ItemPreview() {
  const dispatch = useDispatch();
  const previewedItem = useSelector((state) => state.EMenu.previewedItem);
  const previewItem = useSelector((state) => state.EMenu.previewItem);
  const C_URL = useSelector((state) => state.Company.c_url);
  const t_id = useSelector((state) => state.Company.t_id);
  const chargeType = useSelector((state) => state.Tax.chargeType);
  const sumOfTax = useSelector((state) => state.Tax.sumOfTax);
  const [note, setNote] = useState();
  const [loading, setLoading] = useState(false);

  const cartItems = useSelector((state) => state.EMenu.cartItems);

  const filteredCart = cartItems.find(
    (cartItem) => cartItem?.ProductId === previewedItem?.productid
  );
  const Amount =
    chargeType === "1"
      ? Number(previewedItem?.storePrice)
      : Number(previewedItem?.storePrice) +
        Number(previewedItem?.storePrice * sumOfTax);
  const itemUnit = JSON.parse(localStorage.getItem("product unit"));

  const [imageUrl, setImageUrl] = useState("");

  const handleImageError = () => {
    setImageUrl(fallbackImage);
  };

  useEffect(() => {
    if (previewedItem) {
      setLoading(!loading);
      setImageUrl(
        `https://${C_URL}/storage/uploads/tenant/${t_id}/product/${previewedItem?.image}`
      );
    }
  }, [previewedItem]);

  const handleClose = () => {
    dispatch(EMenuActions.setPreviewItem(!previewItem));
    dispatch(EMenuActions.setPreviewedItem([]));
  };
  const handleDecrement = () => {
    if (filteredCart) {
      const { ProductId } = filteredCart;
      dispatch(EMenuActions.removeFromCart({ ProductId }));
    }
  };
  const handleIncrement = () => {
    if (filteredCart) {
      const { ProductId, ProductName, Price, image, Quantity, TotalPrice } =
        filteredCart;

      dispatch(
        EMenuActions.addToCart({
          ProductId,
          ProductName,
          Price,
          image,
          Quantity,
          TotalPrice,
        })
      );
    }
  };
  const handleClick = () => {
    dispatch(
      EMenuActions.addToCart({
        ProductId: previewedItem?.productid || "",
        image: previewedItem?.image || "",
        ProductName: previewedItem?.name || "",
        description: previewedItem?.description || "",
        time: previewedItem?.cooktime || "",
        Price: Amount || "",
        Quantity: 1,
        inclusiveTax:
          Number(previewedItem?.storePrice) -
          Number(previewedItem?.storePrice) * Number(sumOfTax),
        sellPrice: Number(previewedItem?.storePrice),
        ItemNote: note || "",
      })
    );
    // setLoading(!loading);
    toast.success("Successfully Added to tray 👍", {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
    setTimeout(() => setNote(""), 3000);
  };

  const formatAmount = Number(Amount).toLocaleString("en-NG", {
    style: "currency",
    currency: "NGN",
  });
  return (
    <section className="bg-dark/30 fixed z-10 inset-0 py-4 overflow-auto flex items-center justify-center">
      <div className="relative flex bg-white rounded-lg p-4 md:p-8 max-w-lg w-full md:mx-auto h-[90vh]">
        {/* Close Icon */}
        <div className="absolute top-2 right-1 lg:right-2 z-20">
          <FontAwesomeIcon
            icon={faXmark}
            size="sm"
            className="text-danger p-1 border-danger border-2 rounded-lg bg-danger/10 cursor-pointer"
            onClick={handleClose}
          />
        </div>
        {/* Item Preview Card Content */}
        <div className="flex flex-col items-center">
          <div className="mb-4 w-full rounded-lg overflow-hidden">
            {!loading ? (
              <Skeleton height={300} width={450} />
            ) : (
              <img
                src={imageUrl}
                alt={previewedItem?.image}
                onError={handleImageError}
                className="w-[450px] h-[350px] max-sm:h-[250px] max-sm:w-[100%] object-contain object-center"
              />
            )}
          </div>
          <div className="p-3 w-[90%] mx-auto">
            <div className="flex flex-row gap-4 h-[20%]">
              <p className="w-1/2 text-sm font-semibold text-dark mb-2">
                {previewedItem?.name}
              </p>
              <p className="w-1/2 flex flex-col font-bold text-dark text-right">
                <span className="tracking-tighter text-3xl">
                  {!loading ? <Skeleton width={80} /> : formatAmount}
                </span>
                <span className="text-sm text-secondary ml-2 uppercase">
                  per {itemUnit?.unit_name || "PCS"}
                </span>
              </p>
            </div>

            {previewedItem?.CookTime !== "0" && (
              <p className="text-gray-600 text-sm font-bold mt-2">
                <FontAwesomeIcon
                  icon={faClockFour}
                  className="text-secondary mr-1"
                />
                Ready in {previewedItem?.CookTime} minute
              </p>
            )}
            <p className="text-sm text-dark mt-4 mb-2">
              {previewedItem?.description}
            </p>
            <div className="w-full mb-2">
              <textarea
                className="w-full rounded-lg resize-none p-2 border-2 border-dark/10 placeholder:text-xs"
                rows={2}
                placeholder="Add extra note..."
                value={note}
                onChange={(e) => setNote(e.target.value)}
              />
            </div>
            {previewedItem?.Quantity}
            {!filteredCart?.Quantity ? (
              <Button
                type={"iconBtn"}
                icon={"Add to Cart"}
                bgColor={"bg-secondary"}
                textColor={"text-white"}
                onClick={handleClick}
              />
            ) : (
              <div className="h-full max-sm:h-auto max-sm:w-[90%] px-5 pt-2 lg:w-[70%] mx-auto">
                <div className="flex flex-row gap-2 items-center w-full">
                  <FontAwesomeIcon
                    onClick={handleDecrement}
                    icon={faMinus}
                    className="w-[25%] p-2 rounded-lg bg-white border-2 hover:border-primary text-primary hover:bg-primary hover:text-white"
                  />
                  <p className="w-[50%] text-center p-2">
                    {filteredCart?.Quantity}
                  </p>
                  <FontAwesomeIcon
                    onClick={() =>
                      handleIncrement(
                        previewItem?.ProductId,
                        previewItem?.image,
                        previewItem?.ProductName,
                        previewItem?.Price,
                        previewItem?.Quantity,
                        previewItem?.TotalPrice
                      )
                    }
                    icon={faPlus}
                    className="w-[25%] p-2 rounded-lg bg-white border-2 hover:border-primary text-primary hover:bg-primary hover:text-white"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
